var K = Object.defineProperty;
var H = (e, t, r) => t in e ? K(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var a = (e, t, r) => H(e, typeof t != "symbol" ? t + "" : t, r);
import I, { unref as B, onMounted as Q, nextTick as z, ref as M, readonly as X, watch as $, getCurrentInstance as Y, getCurrentScope as Z, onScopeDispose as q, shallowRef as ee, computed as A } from "vue";
class F {
  constructor(t, r) {
    a(this, "roles");
    a(this, "actions");
    this.roles = t, this.actions = r;
  }
  static tryParse(t, r) {
    if (!t)
      return console.error("Error executing 'AuthPermission.tryParse': Empty roles"), null;
    if (!r)
      return console.error("Error executing 'AuthPermission.tryParse': Empty actions"), null;
    try {
      return new F(t, r);
    } catch (n) {
      return console.error("Error parsing AuthPermission", n), null;
    }
  }
  get allRoles() {
    return [...this.roles];
  }
  get allActions() {
    return [...this.actions];
  }
  checkPermission(t) {
    return t.length === 0 ? !0 : t.some((r) => this.actions.includes(r));
  }
  checkProductPermission(t, r) {
    if (r.length === 0)
      return !0;
    const n = t.toUpperCase();
    return r.some((i) => this.actions.includes(`${n}_${i}`));
  }
  requirePermission(t) {
    const r = this.checkPermission(t);
    return r || console.warn("Unauthorized access attempt"), r;
  }
}
class O {
  constructor(t) {
    a(this, "raw");
    a(this, "sub");
    a(this, "aud");
    a(this, "email");
    a(this, "iss");
    a(this, "contextData");
    a(this, "exp");
    this.raw = t;
    const r = this.parsePayload(t);
    this.sub = r.sub, this.aud = r.aud, this.email = r.email, this.iss = r.iss, this.contextData = r.contexts, this.exp = new Date(r.exp * 1e3);
  }
  static parse(t) {
    return new O(t);
  }
  static tryParse(t) {
    if (!t)
      return null;
    try {
      return new O(t);
    } catch (r) {
      return console.error("Error parsing AuthToken", r), null;
    }
  }
  isValid() {
    return !!this.sub && !!this.aud;
  }
  get contexts() {
    return Array.isArray(this.contextData) ? this.contextData : Object.keys(this.contextData ?? {});
  }
  get userId() {
    return this.sub;
  }
  parsePayload(t) {
    const r = t == null ? void 0 : t.split(".")[1];
    if (r) {
      const n = window.atob(r);
      return JSON.parse(n);
    }
    throw new Error("Unable to parse JWT");
  }
}
class x {
  constructor(t) {
    a(this, "raw");
    a(this, "id");
    a(this, "username");
    a(this, "email");
    a(this, "firstName");
    a(this, "lastName");
    a(this, "language");
    a(this, "unit");
    a(this, "termsAndConditions");
    this.raw = t, this.id = t.id, this.username = t.username, this.email = t.email, this.firstName = t.firstName, this.lastName = t.lastName, this.language = t.language, this.unit = t.unit, this.termsAndConditions = t.termsAndConditions;
  }
  static parse(t) {
    return new x(t);
  }
  static tryParse(t) {
    if (!t || !t.id)
      return null;
    try {
      return new x(t);
    } catch (r) {
      return console.error("Error parsing AuthUser", r), null;
    }
  }
  get fullName() {
    return this.firstName && this.lastName ? `${this.firstName} ${this.lastName}` : this.firstName ? this.firstName : this.lastName ? this.lastName : "";
  }
  profileCompleted() {
    return !!this.firstName && !!this.lastName && !!this.unit;
  }
}
I.util.warn;
function te(e) {
  return Z() ? (q(e), !0) : !1;
}
function k(e) {
  return typeof e == "function" ? e() : B(e);
}
const re = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const ne = Object.prototype.toString, se = (e) => ne.call(e) === "[object Object]", ie = () => {
};
function oe(e, t) {
  function r(...n) {
    return new Promise((i, u) => {
      Promise.resolve(e(() => t.apply(this, n), { fn: t, thisArg: this, args: n })).then(i).catch(u);
    });
  }
  return r;
}
const U = (e) => e();
function ae(e = U) {
  const t = M(!0);
  function r() {
    t.value = !1;
  }
  function n() {
    t.value = !0;
  }
  const i = (...u) => {
    t.value && e(...u);
  };
  return { isActive: X(t), pause: r, resume: n, eventFilter: i };
}
function ue(e) {
  return Y();
}
function le(e, t, r = {}) {
  const {
    eventFilter: n = U,
    ...i
  } = r;
  return $(
    e,
    oe(
      n,
      t
    ),
    i
  );
}
function ce(e, t, r = {}) {
  const {
    eventFilter: n,
    ...i
  } = r, { eventFilter: u, pause: h, resume: y, isActive: g } = ae(n);
  return { stop: le(
    e,
    t,
    {
      ...i,
      eventFilter: u
    }
  ), pause: h, resume: y, isActive: g };
}
function fe(e, t = !0, r) {
  ue() ? Q(e, r) : t ? e() : z(e);
}
const C = re ? window : void 0;
function pe(e) {
  var t;
  const r = k(e);
  return (t = r == null ? void 0 : r.$el) != null ? t : r;
}
function V(...e) {
  let t, r, n, i;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([r, n, i] = e, t = C) : [t, r, n, i] = e, !t)
    return ie;
  Array.isArray(r) || (r = [r]), Array.isArray(n) || (n = [n]);
  const u = [], h = () => {
    u.forEach((c) => c()), u.length = 0;
  }, y = (c, o, d, m) => (c.addEventListener(o, d, m), () => c.removeEventListener(o, d, m)), g = $(
    () => [pe(t), k(i)],
    ([c, o]) => {
      if (h(), !c)
        return;
      const d = se(o) ? { ...o } : o;
      u.push(
        ...r.flatMap((m) => n.map((v) => y(c, m, v, d)))
      );
    },
    { immediate: !0, flush: "post" }
  ), p = () => {
    g(), h();
  };
  return te(p), p;
}
const P = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, E = "__vueuse_ssr_handlers__", he = /* @__PURE__ */ de();
function de() {
  return E in P || (P[E] = P[E] || {}), P[E];
}
function me(e, t) {
  return he[e] || t;
}
function ye(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
const ge = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, _ = "vueuse-storage";
function D(e, t, r, n = {}) {
  var i;
  const {
    flush: u = "pre",
    deep: h = !0,
    listenToStorageChanges: y = !0,
    writeDefaults: g = !0,
    mergeDefaults: p = !1,
    shallow: c,
    window: o = C,
    eventFilter: d,
    onError: m = (s) => {
      console.error(s);
    },
    initOnMounted: v
  } = n, w = (c ? ee : M)(typeof t == "function" ? t() : t);
  if (!r)
    try {
      r = me("getDefaultStorage", () => {
        var s;
        return (s = C) == null ? void 0 : s.localStorage;
      })();
    } catch (s) {
      m(s);
    }
  if (!r)
    return w;
  const b = k(t), T = ye(b), S = (i = n.serializer) != null ? i : ge[T], { pause: j, resume: W } = ce(
    w,
    () => L(w.value),
    { flush: u, deep: h, eventFilter: d }
  );
  o && y && fe(() => {
    r instanceof Storage ? V(o, "storage", N) : V(o, _, G), v && N();
  }), v || N();
  function J(s, l) {
    if (o) {
      const f = {
        key: e,
        oldValue: s,
        newValue: l,
        storageArea: r
      };
      o.dispatchEvent(r instanceof Storage ? new StorageEvent("storage", f) : new CustomEvent(_, {
        detail: f
      }));
    }
  }
  function L(s) {
    try {
      const l = r.getItem(e);
      if (s == null)
        J(l, null), r.removeItem(e);
      else {
        const f = S.write(s);
        l !== f && (r.setItem(e, f), J(l, f));
      }
    } catch (l) {
      m(l);
    }
  }
  function R(s) {
    const l = s ? s.newValue : r.getItem(e);
    if (l == null)
      return g && b != null && r.setItem(e, S.write(b)), b;
    if (!s && p) {
      const f = S.read(l);
      return typeof p == "function" ? p(f, b) : T === "object" && !Array.isArray(f) ? { ...b, ...f } : f;
    } else return typeof l != "string" ? l : S.read(l);
  }
  function N(s) {
    if (!(s && s.storageArea !== r)) {
      if (s && s.key == null) {
        w.value = b;
        return;
      }
      if (!(s && s.key !== e)) {
        j();
        try {
          (s == null ? void 0 : s.newValue) !== S.write(w.value) && (w.value = R(s));
        } catch (l) {
          m(l);
        } finally {
          s ? z(W) : W();
        }
      }
    }
  }
  function G(s) {
    N(s.detail);
  }
  return w;
}
const ve = () => {
  const e = D("piniaToken", null), t = D("piniaUser", {}), r = D("piniaRoles", []), n = D("piniaPermission", []), i = A(() => O.tryParse(e.value)), u = A(() => x.tryParse(t.value)), h = A(() => {
    var o;
    return ((o = i.value) == null ? void 0 : o.isValid()) ?? !1;
  }), y = A(
    () => F.tryParse(r.value, n.value)
  );
  function g(o) {
    e.value = o;
  }
  function p(o) {
    t.value = o;
  }
  function c(o, d) {
    r.value = o, n.value = d;
  }
  return {
    token: i,
    user: u,
    authenticated: h,
    permission: y,
    updateToken: g,
    updateUser: p,
    updatePermission: c
  };
};
function we(e) {
  return `token_${e}`;
}
function Ne(e) {
  const t = we(e), r = document.cookie.split(";");
  for (let n = 0; n < r.length; n += 1) {
    const i = r[n].split("=").map((u) => u.trim());
    if ((i == null ? void 0 : i.length) !== 2)
      return null;
    if (i[0] === t)
      return i[1];
  }
  return null;
}
export {
  F as AuthPermission,
  O as AuthToken,
  x as AuthUser,
  ve as compositionAuthStore,
  Ne as getGlobalAuthentication,
  we as globalAuthenticationKey
};
